import { Button, VStack } from '@chakra-ui/react'
import { BoldTranslation, Heading } from '@missionlabs/react'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AppConfig } from 'shared/utils/env'

export const WhatsAppLanding: FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <VStack maxW="100%" align="start">
            <Heading size="h3" py="1">
                {t('admin.whatsapp.landing.title', { brand: AppConfig.name })}
            </Heading>
            <BoldTranslation
                i18nKey="admin.whatsapp.landing.description"
                fontWeight={500}
                values={{ brand: AppConfig.name }}
            />
            <Button onClick={() => navigate('/admin/whatsapp/signup')}>
                {t('admin.whatsapp.landing.getStarted')}
            </Button>
        </VStack>
    )
}
